function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import Base from "../Base/Base";
import UsageHintComponent from "../UsageHint/UsageHint";
import "./InputWrapper.css";
import classnames from "classnames";
const labelSizeMap = {
  small: "small",
  medium: "body",
  large: "large"
};
export default class InputWrapper extends Component {
  render() {
    const {
      children,
      inlineLabel,
      disabled,
      hasFocus,
      invalid,
      isTarget,
      isValid,
      label,
      labelSpace,
      size,
      space,
      style,
      usageHint,
      usageHintPosition,
      valid,
      inputFeedback,
      ...rest
    } = this.props;
    const classes = classnames("ax-input__wrapper", {
      "ax-input__wrapper--target": isTarget,
      "ax-input__wrapper--inline": inlineLabel
    });
    const innerClasses = classnames("ax-input__icon-container", {
      [`ax-input__icon-container--${size}`]: size,
      [`ax-input__icon-container--${style}`]: style,
      "ax-input__icon-container--disabled": disabled,
      "ax-input__icon-container--focused": hasFocus,
      "ax-input__icon-container--valid": valid,
      "ax-input__icon-container--invalid": invalid || isValid === false
    });
    const inputWrapperSpace = inlineLabel ? "x0" : labelSpace;
    return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      Component: "label",
      className: classes,
      space: space
    }), (label || usageHint || inputFeedback) && /*#__PURE__*/React.createElement(Base, {
      className: "ax-input__hint-wrapper",
      space: inputWrapperSpace
    }, label && /*#__PURE__*/React.createElement(Base, {
      className: "ax-input__wrapper--label",
      textSize: labelSizeMap[size]
    }, label), usageHint && /*#__PURE__*/React.createElement("div", {
      className: "ax-input__hint"
    }, /*#__PURE__*/React.createElement(UsageHintComponent, {
      position: usageHintPosition
    }, usageHint)), inputFeedback && !inlineLabel && /*#__PURE__*/React.createElement("div", {
      className: "ax-input__feedback"
    }, inputFeedback)), /*#__PURE__*/React.createElement("div", {
      className: innerClasses
    }, children));
  }

}

_defineProperty(InputWrapper, "defaultProps", {
  size: "medium",
  space: "x4",
  labelSpace: "x2",
  inlineLabel: false
});